import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=95176384&"
import script from "./Autocomplete.vue?vue&type=script&lang=js&"
export * from "./Autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/github_repos/Ribovision_2.0_GT/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95176384')) {
      api.createRecord('95176384', component.options)
    } else {
      api.reload('95176384', component.options)
    }
    module.hot.accept("./Autocomplete.vue?vue&type=template&id=95176384&", function () {
      api.rerender('95176384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components/Autocomplete.vue"
export default component.exports